/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TVNBListDTO } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface VNBPLZServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param zipCode 
     */
    apiVNBPLZZipCodeGet(zipCode: string, extraHttpRequestParams?: any): Observable<TVNBListDTO>;

}
